<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 pb3 mb2 shadow">
          <div class="col-12 p2">
            <p class="h4 semi-bold darkblue line-height-4 gibson">
              Opgaver fra Håndværker.dk
            </p>
            <template>
              <div v-if="!show">
                <p class="h5 regular darkblue line-height-golden gibson">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi iure adipisci fugit aspernatur illo.</p>
              </div>
              <div v-else>
                <p class="h5 muted-background darkblue col-12 shadow mb2 line-height-3 gibson">
                  Ingen poster
                </p>
              </div>
            </template>
          </div>
        </div>
        <haandvaerker></haandvaerker>
        <customers v-if="!show"></customers>
      </div>
    </div>
  </div>
</template>
<script>
import customers from './Customers'
import Haandvaerker from './haandvaerker'
export default {
  components: {
    Haandvaerker,
    customers
  },
  data () {
    return {
      customers: [],
      show: false
    }
  },
  created () {
    if (localStorage.getItem('haaid') === '0') {
      this.show = true
    }
  }
}
</script>
<style>
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
}
</style>


// WEBPACK FOOTER //
// Opgaveoversigt.vue?89f0c904